import React from 'react';
import styled from 'styled-components';
import { Button, Divider, Spin, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { TABS } from '../../../constants/navigation';

const StyledRequestItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const getEventsLength = (type, length) => {
  if (type === TABS.EVENTS.title) {
    return `(${length})`;
  }

  return '';
};

const CsvRequests = ({ requests, onRequestCancel, closeMenu }) => {
  const renderRequestItem = (requestData) => {
    const { type, executeId, events } = requestData;
    const canselRequest = () => {
      if (requests.length === 1) {
        closeMenu();
      }
      onRequestCancel(executeId);
    };

    return (
      <StyledRequestItem key={executeId}>
        <Tooltip title={events.join(', ')} overlayInnerStyle={{ fontSize: '12px' }}>
          <div style={{ display: 'flex' }}>
            <div>
              <Spin spinning size="small" />
            </div>
            <div style={{ paddingLeft: '5px', cursor: 'default' }}>
              {type} {getEventsLength(type, events.length)}
            </div>
          </div>
        </Tooltip>
        <Button type="text" onClick={canselRequest} icon={<CloseOutlined />} />
      </StyledRequestItem>
    );
  };

  return requests.length ? (
    <>
      <Divider
        style={{
          color: 'rgb(235 164 5)',
          margin: 0,
          fontSize: '12px',
          borderColor: 'rgb(235 164 5)',
        }}
      >
        Download Request(s)
      </Divider>
      {requests.map(renderRequestItem)}
    </>
  ) : null;
};

export default CsvRequests;
